import { MutationHookOptions, MutationTuple, useMutation } from '@apollo/client';

import {
  evictCache,
  CreateContributorMutation,
  CreateContributorMutationVariables,
  CREATE_CONTRIBUTOR,
} from '@neo.tax/shared';

export type Contributor = CreateContributorMutation['createContributor'];
export type UseCreateContributorResult = MutationTuple<CreateContributorMutation, CreateContributorMutationVariables>;

export const useCreateContributor = (
  options?: MutationHookOptions<CreateContributorMutation, CreateContributorMutationVariables>,
): UseCreateContributorResult =>
  useMutation<CreateContributorMutation, CreateContributorMutationVariables>(CREATE_CONTRIBUTOR, {
    context: {
      successToast: {
        title: 'Team member created successfully',
      },
      errorToast: {
        title: 'Error creating team member',
        description: 'Something unexpected prevented your changes from saving. Please try again.',
      },
    },
    update: (cache) => {
      evictCache(cache, ['getAscProjectTeamMembers']);
    },
    ...options,
  });
